'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dLeft from "./scala.util.-Left.js";
import * as $j_scala$002eutil$002e$002dTry from "./scala.util.-Try.js";
var $p;
/** @constructor */
function $c_s_util_Failure(exception) {
  this.h8 = null;
  this.h8 = exception;
}
export { $c_s_util_Failure as $c_s_util_Failure };
$p = $c_s_util_Failure.prototype = new $j_scala$002eutil$002e$002dTry.$h_s_util_Try();
$p.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
}
export { $h_s_util_Failure as $h_s_util_Failure };
$h_s_util_Failure.prototype = $p;
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1408943127), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_s_util_Failure)) {
    var x = this.h8;
    var x$2 = x$0.h8;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "Failure";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.h8;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.Pi = (function() {
  return true;
});
$p.Pk = (function() {
  return false;
});
$p.C = (function() {
  var $x_1 = this.h8;
  throw (($x_1 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? $x_1.aZ : $x_1);
});
$p.P9 = (function(default$1) {
  return default$1.h();
});
$p.a6 = (function(f) {
});
$p.ra = (function(f) {
  return this;
});
$p.QL = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_None$();
});
$p.QG = (function() {
  return new $j_scala$002eutil$002e$002dLeft.$c_s_util_Left(this.h8);
});
$p.eT = (function(fa, fb) {
  return fa.j(this.h8);
});
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g8)));
}
export { $isArrayOf_s_util_Failure as $isArrayOf_s_util_Failure };
var $d_s_util_Failure = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Failure, "scala.util.Failure", ({
  g8: 1,
  gc: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_s_util_Failure as $d_s_util_Failure };
